import Controller, { OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { ContextualBarAPI, PanelAPI, TabControlAPI, TabWithContentAPI } from '@philips-internal/oswald-ui-components';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import { Inject } from '@odinjs/odin';

import BaseController from '../../../BaseController';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { WoundsDressingsTabListAliases as Alias, FragmentNames } from '../../../../codegen';
import { WoundsDressingsTabListContext } from '../../service/wounds-dressing-tab-list-service';
import { WoundsDressingTabType } from '../../types/wounds-dressings-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

@Controller({component: Alias.LAYOUT_WOUNDS_DRESSINGS_TAB_LIST, fragment: FragmentNames.WOUNDS_DRESSINGS_TAB_LIST })
export default class WoundsDressingsTabListController extends BaseController {
  @Inject(Alias.PANEL_TAB_CONTROL)
  private panelTabControlAPI!: PanelAPI;

  @Inject(Alias.TAB_CONTROL)
  private tabControlAPI!: TabControlAPI;

  @Inject(Alias.CONTEXTUAL_BAR)
  private contextualBarAPI!: ContextualBarAPI;

  private activeTab(tab: TabWithContentAPI, idWoundsDressings: string): void {
    tab.setVisible(true);
    tab.setActiveTab(idWoundsDressings)
  }

  @OnMount(Alias.CONTEXTUAL_BAR)
  handleOnMountContextualBar(): void {
    const dressingText = MessageService.translate('text.dressing');
    const { woundLocation } = this.historyService.getCurrentRouteParams();
    const contextualBarTitle = `${dressingText}: ${woundLocation}`;
    this.contextualBarAPI.setTitle(contextualBarTitle);
  }

  @OnMount(Alias.LAYOUT_WOUNDS_DRESSINGS_TAB_LIST)
  handleOnMount(): void {
    const {encounterId, patientId, woundId} = this.historyService.getCurrentRouteParams()
    InformationBarUtils.collapsedBar = true;
    this.context.set({ encounterId, patientId, woundId });
    this.panelTabControlAPI.setVisible(true);
  }

  @OnMount(Alias.TAB_CONTROL)
  handleMountTabControl(): void {
    const currentTab = WoundsDressingsTabListContext.currentTab;
    this.tabControlAPI.setActiveTab(!currentTab ? WoundsDressingTabType.WOUNDS : currentTab);
    WoundsDressingsTabListContext.currentTab = this.tabControlAPI.getActiveTab();
  }

  @OnMount(Alias.TAB_WITH_CONTENT_DRESSINGS)
  handleMountTabWithContentDressings(event: MountEvent): void {
    const tabApi = event.target as TabWithContentAPI;
    this.activeTab(tabApi, WoundsDressingTabType.DRESSINGS);
    WoundsDressingsTabListContext.clean();
  }

  @OnMount(Alias.TAB_WITH_CONTENT_WOUNDS_IMAGES)
  handleMountTabWithContentWoundsImages(event: MountEvent): void {
    const tabApi = event.target as TabWithContentAPI;
    this.activeTab(tabApi, WoundsDressingTabType.IMAGES);
  }

  @OnMount(Alias.TAB_WITH_CONTENT_WOUNDS)
  handleMountTabWithContentWounds(event: MountEvent): void {
    const tabApi = event.target as TabWithContentAPI;
    this.activeTab(tabApi, WoundsDressingTabType.WOUNDS);
    WoundsDressingsTabListContext.clean();
  }

  @OnUnmount(Alias.LAYOUT_WOUNDS_DRESSINGS_TAB_LIST)
  handleUnmountRoot(): void {
    WoundsDressingsTabListContext.clean();
  }
}
